<template>
  <a
    :href="hrefZipUrl"
    class="text-anchor pointer-cursor"
    target="_blank"
    v-b-tooltip.hover
    title="Download file"
    v-if="hrefZipUrl"
  >
    <b-button>
      <font-awesome-icon icon="download" class="icon-download"></font-awesome-icon>
      Download Zip
    </b-button>
  </a>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';

library.add(faFileDownload);

export default {
  props: {
    // file type:  bank_statement, financial_stmt, etc.
    type: { type: String, default: '' },
    // category:  docs, entities, loans
    category: { type: String, default: '' },
    // entities:  entity id for entities
    entities: { type: String, default: '' },
    numberOfFiles: { type: Number, default: 1 },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    hrefZipUrl() {
      // this query extension is to bypass Chrome caching feature by generating unique URLs.
      const urlQueryExtension = `?files=${this.numberOfFiles}&n=${this.randomInteger()}`;
      if (this.category === 'docs') {
        return `/users/${this.user.id}/${this.category}/get_zip/${this.type}${urlQueryExtension}`;
      } else if (this.category === 'entities') {
        return `/users/${this.user.id}/${this.category}/${this.entities}/get_zip/${this.type}${urlQueryExtension}`;
      }
      return null;
    },
  },
  methods: {
    randomInteger() {
      return Math.floor(Math.random() * 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/misc/ZipFilesButton.vue